<template>
  <div>
    <Snackbar />
    <Overlay />
    <v-app-bar app clipped-left dark elevation="1" dense>
      <!-- <v-app-bar-nav-icon @click="setDrawer(!$store.getters.getDrawer)"></v-app-bar-nav-icon> -->
      <span class="hidden-sm-and-down title ml-3 mr-5">
        Click&nbsp;
        <span class="font-weight-light">PDV</span>
      </span>
      <v-spacer></v-spacer>
      <!--<v-select
        flat
        solo-inverted
        hide-details
        dense
        :items="getEmpresas"
        v-model="empresaSelecionada"
        label="Unidade"
        item-text="razao_social"
        item-value="id"
        @change="setEmpresaSelecionada(empresaSelecionada)"
        return-object
      >
      </v-select> -->

      <v-spacer></v-spacer>
      <span class="hidden-sm-and-down"
        >Olá, {{ $helper.firstName($store.getters.getUser.nome) }}</span
      >

      <div class="text-center">
        <v-menu
          v-model="menuNotificacoes"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-badge bordered overlap dot color="pink">
                <v-icon>notifications</v-icon>
              </v-badge>
            </v-btn>
          </template>

          <v-card max-height="600px">
            <v-list>
              <v-list-item>
                <v-icon>notifications</v-icon>

                <v-list-item-content>
                  <v-list-item-title
                    >Notificações ({{
                      getNotificacoes.length
                    }})</v-list-item-title
                  >
                </v-list-item-content>

                <v-list-item-action> </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-list two-line>
              <v-list-item-group class="ma-0">
                <template v-for="(item, index) in getNotificacoes">
                  <v-list-item
                    :key="item.id"
                    @click="
                      visualizarNotificacao(item), (menuNotificacoes = false)
                    "
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title>{{
                          item.descricao
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
                <!-- <v-list-item-title></v-list-item-title  st-item-title> -->
              </v-list-item-group>
            </v-list>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="menuNotificacoes = false"> Fechar </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$router.push({ name: 'senha' })">
            <v-list-item-title>Senha</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Sair (CTRL + Q)</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer app clipped width="300" dark permanent expand-on-hover>
      <v-list nav dense>
        <v-list-item
          @click="$router.push({ name: 'vendaCadastro' })"
          v-if="$helper.verificaPermissao('cadastrar-venda')"
        >
          <v-icon class="mr-8">local_atm</v-icon>
          <v-list-item-content>
            <v-list-item-title>PDV</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="$router.push({ name: 'ordensDeServico' })"
            v-if="$helper.verificaPermissao('visualizar-ordem-servico')"
        >
          <v-icon class="mr-8">mdi-ballot</v-icon>
          <v-list-item-content>
            <v-list-item-title>Serviços</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          prepend-icon="content_paste"
          no-action
          v-if="
            $helper.verificaPermissao('visualizar-empresa') ||
            $helper.verificaPermissao('visualizar-contato') ||
            $helper.verificaPermissao('visualizar-estoque') ||
            $helper.verificaPermissao('visualizar-etiqueta') ||
            $helper.verificaPermissao('visualizar-forma-pagamento') ||
            $helper.verificaPermissao('visualizar-funcionario') ||
            $helper.verificaPermissao('visualizar-cargo') ||
            $helper.verificaPermissao('visualizar-perfil') ||
            $helper.verificaPermissao('visualizar-pedido-compra') ||
            $helper.verificaPermissao('visualizar-unidade-medida') ||
            $helper.verificaPermissao('visualizar-modelo-tanque')
          "
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cadastros</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            @click="$router.push({ name: 'empresas' })"
            v-if="$helper.verificaPermissao('visualizar-empresa')"
          >
            <v-list-item-content>
              <v-list-item-title>Empresa</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'contatos' })"
            v-if="$helper.verificaPermissao('visualizar-contato')"
          >
            <v-list-item-content>
              <v-list-item-title>Contatos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'produtos' })"
            v-if="$helper.verificaPermissao('visualizar-produto')"
          >
            <v-list-item-content>
              <v-list-item-title>Produtos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'estoques' })"
            v-if="$helper.verificaPermissao('visualizar-estoque')"
          >
            <v-list-item-content>
              <v-list-item-title>Estoques</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'etiquetaListar' })"
            v-if="$helper.verificaPermissao('visualizar-etiqueta')"
          >
            <v-list-item-content>
              <v-list-item-title>Etiquetas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item @click="$router.push({'name': 'fornecedores'})">
						<v-list-item-content>
							<v-list-item-title class="menuAtivo">Fornecedores</v-list-item-title>
						</v-list-item-content>
					</v-list-item> -->
          <v-list-item
            @click="$router.push({ name: 'formasPagamentos' })"
            v-if="$helper.verificaPermissao('visualizar-forma-pagamento')"
          >
            <v-list-item-content>
              <v-list-item-title>Formas de Pagamento</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'funcionarios' })"
            v-if="$helper.verificaPermissao('visualizar-funcionario')"
          >
            <v-list-item-content>
              <v-list-item-title>Funcionários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'cargos' })"
            v-if="$helper.verificaPermissao('visualizar-cargo')"
          >
            <v-list-item-content>
              <v-list-item-title>Cargos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'perfis' })"
            v-if="$helper.verificaPermissao('visualizar-perfil')"
          >
            <v-list-item-content>
              <v-list-item-title>Perfis</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'permissoes' })"
            v-if="$helper.verificaPermissao('acesso-suporte')"
          >
            <v-list-item-content>
              <v-list-item-title>Permissões</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'pedidosCompras' })"
            v-if="$helper.verificaPermissao('visualizar-pedido-compra')"
          >
            <v-list-item-content>
              <v-list-item-title>Pedido de Compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'entradaMercadoria' })"
            v-if="$helper.verificaPermissao('visualizar-entrada-mercadoria')"
          >
            <v-list-item-content>
              <v-list-item-title>Entrada de Mercadoria</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'unidadeMedidas' })"
            v-if="$helper.verificaPermissao('visualizar-unidade-medida')"
          >
            <v-list-item-content>
              <v-list-item-title>Unidade de Medida</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'modelosTanques' })"
            v-if="$helper.verificaPermissao('visualizar-modelo-tanque')"
          >
            <v-list-item-content>
              <v-list-item-title>Modelos de Tanques</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push({ name: 'NCMListar' })">
            <v-list-item-content>
              <v-list-item-title>NCM</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          @click="$router.push({ name: 'orcamentos' })"
          v-if="this.$helper.verificaPermissao('visualizar-orcamento')"
        >
          <v-icon class="mr-8">receipt</v-icon>
          <v-list-item-content>
            <v-list-item-title>Orçamentos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push({ name: 'vendas' })">
          <v-icon class="mr-8">stacked_line_chart</v-icon>
          <v-list-item-content>
            <v-list-item-title>Vendas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          prepend-icon="pie_chart"
          no-action
          v-if="
            $helper.verificaPermissao('visualizar-banco') ||
            $helper.verificaPermissao('visualizar-banco') ||
            $helper.verificaPermissao('visualizar-categoria-financeiro') ||
            $helper.verificaPermissao('visualizar-conta-pagar') ||
            $helper.verificaPermissao('visualizar-conta-receber') ||
            $helper.verificaPermissao('visualizar-fluxo-caixa')
          "
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Financeiro</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            @click="$router.push({ name: 'lancamentosBancarios' })"
            v-if="$helper.verificaPermissao('visualizar-banco')"
          >
            <v-list-item-content>
              <v-list-item-title>Lançamentos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'bancos' })"
            v-if="$helper.verificaPermissao('visualizar-banco')"
          >
            <v-list-item-content>
              <v-list-item-title>Bancos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'gruposFinanceiro' })"
            v-if="
              this.$helper.verificaPermissao('visualizar-categoria-financeiro')
            "
          >
            <v-list-item-content>
              <v-list-item-title>Categorias</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'contasPagar' })"
            v-if="$helper.verificaPermissao('visualizar-conta-pagar')"
          >
            <v-list-item-content>
              <v-list-item-title>Contas a Pagar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'contasReceber' })"
            v-if="$helper.verificaPermissao('visualizar-conta-receber')"
          >
            <v-list-item-content>
              <v-list-item-title>Contas a Receber</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="$router.push({ name: 'fluxoCaixa' })"
            v-if="$helper.verificaPermissao('visualizar-fluxo-caixa')"
          >
            <v-list-item-content>
              <v-list-item-title>Fluxo de Caixa</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="text_snippet"
          no-action
          v-if="
            $helper.verificaPermissao('visualizar-relatorio-notas-fiscais') ||
            $helper.verificaPermissao('visualizar-relatorio-ordem-servico') ||
            $helper.verificaPermissao('visualizar-relatorio-vendas')
          "
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Relatórios</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            @click="$router.push({ name: 'relatorioNotas' })"
            v-if="
              $helper.verificaPermissao('visualizar-relatorio-notas-fiscais')
            "
          >
            <v-list-item-content>
              <v-list-item-title>Notas Fiscais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'relatorioVendas' })"
            v-if="$helper.verificaPermissao('visualizar-relatorio-vendas')"
          >
            <v-list-item-content>
              <v-list-item-title>Vendas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'relatorioOs' })"
            v-if="
              $helper.verificaPermissao('visualizar-relatorio-ordem-servico')
            "
          >
            <v-list-item-content>
              <v-list-item-title>Ordens de Serviços</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'logs' })"
            v-if="$helper.verificaPermissao('listar-logs')"
          >
            <v-list-item-content>
              <v-list-item-title>Logs dos usuários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- <v-list-group
          prepend-icon="mdi-ballot"
          no-action
          v-if="$helper.verificaPermissao('visualizar-ordem-servico')"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Serviços</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            @click="$router.push({ name: 'ordensDeServico' })"
            v-if="$helper.verificaPermissao('visualizar-ordem-servico')"
          >
            <v-list-item-content>
              <v-list-item-title>Ordens de Serviço</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group> -->
        <v-list-group
          prepend-icon="tag_faces"
          no-action
          v-if="
            $helper.verificaPermissao('visualizar-pos-venda-crm') ||
            $helper.verificaPermissao('visualizar-crm-propostas-crm')
          "
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>CRM</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            @click="$router.push({ name: 'posVendaListar' })"
            v-if="$helper.verificaPermissao('visualizar-pos-venda-crm')"
          >
            <v-list-item-content>
              <v-list-item-title>Pós-Venda</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'crmPropostaListar' })"
            v-if="$helper.verificaPermissao('visualizar-propostas-crm')"
          >
            <v-list-item-content>
              <v-list-item-title>Propostas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="$router.push({ name: 'pesquisaSatisfacaoListar' })"
            v-if="$helper.verificaPermissao('visualizar-pesquisa-satisfacao')"
          >
            <v-list-item-content>
              <v-list-item-title>Pesquisa de Satisfação</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view></router-view>
    </v-main>
    <ModalPrint />
    <ModalSolicitarPermissaoFuncionario />
    <ModalConfirmacao />
    <Alert />

    <!--
			<Footer/>-->
  </div>
</template>

<script>
import Footer from "../components/core/Footer";
import VueLoad from "../components/shared/VueLoad";
import Snackbar from "@/components/shared/Snackbar";
import Alert from "@/components/shared/Alert";
import Overlay from "@/components/shared/Overlay";
import ModalSolicitarPermissaoFuncionario from "@/pages/funcionario/ModalPermissao";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Footer,
    VueLoad,
    Snackbar,
    Overlay,
    ModalSolicitarPermissaoFuncionario,
    Alert,
  },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    empresaSelecionada: null,
    menuNotificacoes: false,
  }),
  computed: {
    ...mapGetters([
      "getDrawer",
      "getEmpresas",
      "getEmpresaSelecionadaId",
      "getNotificacoes",
    ]),
  },
  methods: {
    ...mapActions([
      "listarEmpresa",
      "setEmpresaSelecionadaId",
      "setEmpresaSelecionada",
      "cadastrarVenda",
      "setDrawer",
      "ativaModalConfirmacao",
      "listarNotificacao",
      "visualizarNotificacao",
    ]),
    logout() {
      sessionStorage.clear();
      this.$router.push({ name: "login" });
      this.$store.commit("setUser", null);
      location.reload();
    },
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 113) e.preventDefault();
      if (keyCode == 114) e.preventDefault();
      if (keyCode == 116) e.preventDefault();
      if (keyCode == 117) e.preventDefault();

      if (keyCode == 81 && e.ctrlKey) {
        this.ativaModalConfirmacao({
          mensagem: "Deseja sair do sistema?",
          action: "logout",
          action_value: false,
        });
      }
    },
  },
  created() {
    this.listarNotificacao();

    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpgradeUI = true;
      });
    }

    let user = sessionStorage.getItem("user");
    if (!user) {
      if (this.$route.name != "login") {
        sessionStorage.redirectTo = window.location.href;
      }
      this.$router.push({ name: "login" });
    }
    this.listarEmpresa();
    this.empresaSelecionada = this.getEmpresaSelecionadaId;
    document.addEventListener("keydown", this.keyUp);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyUp);
  },
};
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none;
}

::-webkit-scrollbar {
  width: 2px;
  border-radius: 10px;
  background: #333;
}

::-webkit-scrollbar-thumb {
  background: rgb(180, 179, 179);
  border-radius: 10px;
}

.menuAtivo {
  color: #ffffff;
  border-radius: 5px;
  margin-right: 5px;
  font-weight: bold;
}
.content {
  border: 1px solid #e2e2e2;
  border-radius: 3px;
  padding: 6px;
}
.v-main {
  padding: 3% 0% 0% 4% !important;
}
</style>
